<template>
  <svg :class="'hb-lv-' + level" width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient :id="'gradient' + level + '-' + _uid" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="-2.47%" :style="'stop-color:' + gradientColors[0]" />
        <stop v-if="gradientColors[1]" offset="49.6%" :style="'stop-color:' + gradientColors[1]" />
        <stop v-if="gradientColors[2]" offset="102.84%" :style="'stop-color:' + gradientColors[2]" />
      </linearGradient>
    </defs>
    <path :fill="'url(#gradient' + level + '-' + _uid + ')'" d="M7.86961 0.300544C8.56369 -0.100181 9.41882 -0.100181 10.1129 0.300544L15.9644 3.6789C16.6585 4.07962 17.086 4.82019 17.086 5.62164V12.3784C17.086 13.1798 16.6585 13.9204 15.9644 14.3211L10.1129 17.6995C9.41882 18.1002 8.56369 18.1002 7.86961 17.6995L2.01813 14.3211C1.32405 13.9204 0.896484 13.1798 0.896484 12.3784V5.62165C0.896484 4.8202 1.32405 4.07962 2.01813 3.6789L7.86961 0.300544Z"/>
  </svg>
</template>

<script>
export default {
  props: ['level'],
  computed: {
    gradientColors() {
      return this.getGradientColors(this.level);
    }
  },
  methods: {
    getGradientColors(level) {
      switch (true) {
        case level <= 3: return ['#C8CDD2', '#B9BEC3'];
        case level <= 6: return ['#96E127', '#80D15C'];
        case level <= 9: return ['#33BFFE', '#339AFE'];
        case level <= 12: return ['#F747FE', '#D647FE'];
        case level <= 15: return ['#FFA001', '#FE8001'];
        case level <= 18: return ['#FF5A97', '#E43956'];
        case level <= 21: return ['#43484D', '#171C21'];
        case level <= 23: return ['#90E737', '#44D1F8', '#8DE73D'];
        case level <= 25: return ['#FF4736', '#FF4A35', '#FE9210'];
        case level <= 29: return ['#040402', '#947220', '#030301'];
        default: return ['#0BFFD9', '#E3DB13', '#FB29FF'];
      }
    }
  }
}
</script>
